<template>
    <div class="address-manage-container">
        <div class="content">
            <van-cell-group>
                <van-field name="name" required clearable :error-message="verifyErrMsg.name" v-model.trim="addressInfo.name" label="姓名" maxlength="50" placeholder="请输入姓名" />
                <van-field
                    required
                    clearable
                    name="phone"
                    :error-message="verifyErrMsg.phone"
                    v-model.trim="addressInfo.phone"
                    label="手机号码"
                    placeholder="请输入手机号码"
                    maxlength="11"
                    type="digit"
                />

                <van-field
                    @click="goLocation"
                    name="address"
                    readonly
                    required
                    clearable
                    :error-message="verifyErrMsg.address"
                    v-model.trim="addressInfo.address"
                    label="所在位置"
                    placeholder="点击选择位置"
                    right-icon="location-o"
                    style="cursor: pointer;"
                />

                <van-field
                    name="addressDetail"
                    type="textarea"
                    maxlength="200"
                    :error-message="verifyErrMsg.addressDetail"
                    v-model.trim="addressInfo.addressDetail"
                    required
                    clearable
                    label="详细地址"
                    placeholder="街道门牌、楼层房间号等信息"
                />
                <van-field name="switch" label="设为默认地址">
                    <template #input>
                        <van-switch v-model.trim="addressInfo.isDefault" size="20" />
                    </template>
                </van-field>
            </van-cell-group>
            <div class="bottom">
                <van-button round block :loading="loading" :disabled="loading" @click="onSave()" size="small" type="primary" native-type="submit">{{ buttonText }}</van-button>
            </div>
        </div>
    </div>
</template>

<script>
import baseApi from '@/api/baseApi';
import manageApi from '@/api/manageApi';
import wx from '@/lib/wx';
import setter from '@/lib/setter';

export default {
    data() {
        return {
            buttonText: '保存',
            loading: false,
            wxApiList: ['getLocation'],
            addressInfo: {
                name: '',
                phone: '',
                address: '',
                addressDetail: '',
                isDefault: false,
                latitude: '',
                longitude: ''
            },
            verifyErrMsg: {
                name: '',
                phone: '',
                address: '',
                addressDetail: ''
            },
            verify: {
                name(value, item) {
                    if (!/[\S]+/.test(value)) {
                        return '请输入姓名';
                    }
                },
                phone(value, item) {
                    if (!/[\S]+/.test(value)) {
                        return '请输入手机号码';
                    }
                    if (!/^1\d{10}$/.test(value)) {
                        return '请输入正确的手机号';
                    }
                },
                address(value, item) {
                    if (!/[\S]+/.test(value)) {
                        return '请选择所在位置';
                    }
                },
                addressDetail(value, item) {
                    if (!/[\S]+/.test(value)) {
                        return '请输入详细地址';
                    }
                }
            }
        };
    },
    created() {
        const { $toast,wxApiList } = this;
        wx.checkJsApi(wxApiList).then((res) => {
            if (res.checkResult.getLocation == false) {
                $toast('你的微信版本太低，请升级到最新的微信版本！');
                return;
            }
        }).catch((err) => {
             
        });
        if (this.id) {
            this.initAddressList();
            this.buttonText = '修改';
        } else {
            //解析地址中的数据
            if (this.$route.query.latng) {
                this.addressInfo.address = this.$route.query.addr;
                this.addressInfo.addressDetail = _.isArray(this.$route.query.name) ? this.$route.query.name[1] : this.$route.query.name;
                let latng = this.$route.query.latng.split(',');
                this.addressInfo.latitude = latng[0];
                this.addressInfo.longitude = latng[1];
            }
            this.addressInfo.name = sessionStorage.getItem('address-name');
            this.addressInfo.phone = sessionStorage.getItem('address-phone');
            this.addressInfo.isDefault = JSON.parse(sessionStorage.getItem('address-default'));
        }
    },
    methods: {
        goLocation() {
            this.goWxMap();
        },
        goWxMap() {
            const { $toast, $dialog, wxApiList } = this;
            wx.checkJsApi(wxApiList).then((res) => {
               if (res.checkResult.getLocation == false) {
                   $toast('你的微信版本太低，请升级到最新的微信版本！');
                   return;
               }
            }).catch((err) => {
                
            });
                
            /* 缓存数据 */
            sessionStorage.clear();
            sessionStorage.setItem('address-name', this.addressInfo.name);
            sessionStorage.setItem('address-phone', this.addressInfo.phone);
            sessionStorage.setItem('address-default', this.addressInfo.isDefault);

            // 这个是获取当前页面的路径
            let url = window.location.href.split('#')[0];
            let key = setter.txMapKey;

            if (this.addressInfo.latitude && this.addressInfo.longitude) {
                let tocoord = this.addressInfo.latitude + ',' + this.addressInfo.longitude;
                let goUrl =
                        'https://apis.map.qq.com/tools/locpicker?search=1&type=0&backurl=' +
                        url +
                        '&key=' +
                        key +
                        '&policy=1&referer=official&coordtype=5&tocoord=' +
                        tocoord +
                        '';
                location.href = goUrl;
            } else if (this.latitude && this.longitude) {
                let tocoord = this.latitude + ',' + this.longitude;
                let goUrl =
                        'https://apis.map.qq.com/tools/locpicker?search=1&type=0&backurl=' +
                        url +
                        '&key=' +
                        key +
                        '&policy=1&referer=official&coordtype=5&tocoord=' +
                        tocoord +
                        '';
                location.href = goUrl;
            } else {
                const { $toast } = this;
                const toastLoad = $toast.loading({
                    message: '定位中...',
                    forbidClick: true,
                    duration: 0,
                    loadingType: 'circular',
                    overlay: true,
                    closeOnClickOverlay: true,
                });
                
                wx.checkJsApiLocation(wxApiList).then((res) => {
                    $toast(res);
                }).catch((msg) => {
                    toastLoad.clear();
                    $toast(msg);
                }).finally((msg) => {
                    toastLoad.clear();
                    $toast(msg);
                });
                
            }
        },
        initAddressList() {
            const { $toast, id } = this;
            manageApi
                .getUserAddress(id)
                .then(res => {
                    const data = res.data;
                    if (data) {
                        this.addressInfo = res.data;
                        if (this.$route.query.addr) {
                            this.addressInfo.address = this.$route.query.addr;
                            this.addressInfo.addressDetail = _.isArray(this.$route.query.name) ? this.$route.query.name[1] : this.$route.query.name;
                            if (this.$route.query.latng) {
                                let latng = this.$route.query.latng.split(',');
                                this.addressInfo.latitude = latng[0];
                                this.addressInfo.longitude = latng[1];
                            }
                        }
                        this.addressInfo.name = sessionStorage.getItem('address-name') ? sessionStorage.getItem('address-name') : this.addressInfo.name;
                        this.addressInfo.phone = sessionStorage.getItem('address-phone') ? sessionStorage.getItem('address-phone') : this.addressInfo.phone;
                        if (data.isDefault || sessionStorage.getItem('address-default') == null) {
                            this.addressInfo.isDefault = data.isDefault;
                        } else {
                            this.addressInfo.isDefault = JSON.parse(sessionStorage.getItem('address-default'));
                        }
                    }
                })
                .catch(() => {})
                .finally(() => {});
        },
        onSave() {
            this.$nextTick().then(() => {
                let keys = Object.keys(this.verify);
                let sign = false;
                for (let key in keys) {
                    let err = this.verify[keys[key]](this.addressInfo[keys[key]], this.addressInfo);
                    if (err) {
                        this.verifyErrMsg[keys[key]] = err;
                        sign = true;
                    } else {
                        this.verifyErrMsg[keys[key]] = '';
                    }
                }
                if (sign) {
                    return;
                }
                const { $toast, $router, addressInfo } = this;
                this.loading = true;
                let organCode = this.organInfo.organCode;
                addressInfo.organId = organCode;
                manageApi
                    .saveUserAddress({ ...addressInfo })
                    .then(res => {
                        
                       const data = res.data;
                        if (this.id) {
                            $toast('修改成功');
                        } else {
                            $toast('添加成功');
                        }
                        sessionStorage.clear();
                        this.$router.push({
                            path: '/manage/address_list'
                        });
                    })
                    .catch(() => {})
                    .finally(() => {
                        this.loading = false;
                    });
            });
        }
    },
    computed: {
        organInfo() {
            return this.$hdk.data(this.$setter.organInfo);
        }
    },
    props: {
        id: {
            type: String,
            required: false
        }
    }
};
</script>

<style lang="less" scoped>
.address-manage-container/deep/.van-field__control:read-only {
    cursor: pointer;
}
.address-manage-container .bottom {
    position: fixed;
    bottom: 0;
    padding: 0.213333rem 0.48rem;
    background-color: @white-color;
    left: 0;
    right: 0;
    height: 0.933333rem;
    box-shadow: 0 -0.06rem 0.1rem 0.04rem rgba(0, 0, 0, 0.03);
    display: flex;
    align-items: center;
}
.address-manage-container .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
}

.address-manage-container .block {
    width: 3.2rem;
    background-color: #fff;
    line-height: 0.8rem;
    padding: 0.4rem 0rem;
}
</style>
